import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=58cbba58&scoped=true"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"
import style0 from "./loader.vue?vue&type=style&index=0&id=58cbba58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cbba58",
  null
  
)

export default component.exports